import React, { useState, useEffect } from "react";
import { useAuth } from "../AuthContext";
import axios from "axios";
import AddLog from "./AddLog"; // ✅ 로그 저장 함수 가져오기

import "../styles/UserEditModal.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const GovernmentEditModal = ({ selectedGovernment, onClose, onSave, onGovernmentAdded, }) => {    
    const { user } = useAuth();
    const [editedGovernment, setEditedGovernment] = useState(selectedGovernment);
    
    // 카카오 주소 검색
    const handleSearchAddress = () => {
        new window.daum.Postcode({
            oncomplete: (data) => {
                // 주소 값을 상태에 저장
                setEditedGovernment((prev) => ({ ...prev, location1: data.address }));
            },
            width: 500, // 창 너비
            height: 600, // 창 높이
        }).open({
            left: (window.screen.width / 2) - 250,  // 중앙 정렬 (화면 너비 기준)
            top: (window.screen.height / 2) - 300   // 중앙 정렬 (화면 높이 기준)
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedGovernment((prev) => ({ ...prev, [name]: value }));
    };

    const handleDelete = async () => {
        const DeleteGovernment = editedGovernment.governmentCode;

        if (!DeleteGovernment) {
            alert("관공서코드가 없습니다.");
            return;
        }

        if (window.confirm(`${DeleteGovernment} 관공서코드를 정말 삭제하시겠습니까?`)) {
            // 삭제 로직 추가
            try {

                const response = await axios.delete(`${API_BASE_URL}/api/Government/delete-government?governmentCode=${DeleteGovernment}`);

                if (response.status === 204) {

                    await AddLog(user.userId, "", DeleteGovernment, "7-4");

                    alert("관공서코드가 삭제되었습니다.");
                    //onSave();  // 리스트 갱신을 요청하는 콜백 호출
                    onGovernmentAdded();
                    onClose();
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    alert("삭제 할 관공서코드를 찾을 수 없습니다.");
                } else {
                    alert("삭제 중 오류발생.");
                }
            }
        }
    };

    const handleSave = async () => { // 'async' 추가

        if (!editedGovernment.governmentName.trim()) {
            alert("관공서명을 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("governmentName")[0].focus();
            }, 0);
            return;
        }
        else if (!editedGovernment.location1.trim()) {
            alert("주소검색으로 기본 소재지를 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("location1bt")[0].focus();
            }, 0);
            return;
        }
        else if (!editedGovernment.location2.trim()) {
            alert("나머지 소재지를 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("location2")[0].focus();
            }, 0);
            return;
        }

        editedGovernment.governmentName = editedGovernment.governmentName.trim();
        editedGovernment.location2 = editedGovernment.location2.trim();

        const updateGovernment = {
            GovernmentCode: editedGovernment.governmentCode,
            GovernmentName: editedGovernment.governmentName,
            Address1: editedGovernment.location1,
            Address2: editedGovernment.location2,
        };
        //console.log("사용자 수정 정보:", JSON.stringify(updateUser, null, 2));
        //alert(updateUser.UserId);

        try {
            
            const response = await fetch(`${API_BASE_URL}/api/Government/update-government`, { 
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updateGovernment),
            });

            const data = await response.json();
            if (response.ok) {

                await AddLog(user.userId, "", updateGovernment.GovernmentCode, "7-2");

                alert("관공서 정보 변경이 완료되었습니다.");
                
                onSave(editedGovernment);
                onClose();
            } else {
                alert("관공서 정보 변경이 실패했습니다: " + data.message);
                //console.log("응답 상태 코드:", response.status);
                //console.log("서버 응답 데이터:", data);
            }

        } catch (error) {
            //console.error("오류:", error);
            alert("관공서 정보 변경 중 오류가 발생했습니다.");
        }

        onClose(); // 팝업 닫기
    };

    

    return (
        <div className="addmodal-overlay">
            <div className="addmodal-content">

                {/* 모달 헤더 */}
                <div className="addmodal-header">
                    <h2>{editedGovernment.snum}.{editedGovernment.governmentCode} Update</h2>
                    <button className="addmodal-close-btn" onClick={onClose}><i className="fa fa-times-circle"></i></button>
                </div>                

                <div className="addform-group">
                    <label>관공서명</label>
                    <div className="addinput-group">
                        <input type="text" maxLength="18" name="governmentName" value={editedGovernment.governmentName} onChange={handleChange} />
                    </div>
                </div>
                
                <div className="addform-group">
                    <label>소재지1</label>
                    <div className="addinput-group">
                        <input type="text" name="location1" readOnly value={editedGovernment.location1 || ""} onChange={handleChange} />
                        <button name="location1bt"  className="addsearch-btn" onClick={handleSearchAddress}><i className="fa fa-search"></i></button>
                    </div>
                </div>

                <div className="addform-group">
                    <label>소재지2</label>
                    <div className="addinput-group">
                        <input type="text" maxLength="40" name="location2" value={editedGovernment.location2} onChange={handleChange} />
                    </div>
                </div>                


                   
                {/* 업데이트 버튼 */}
                <div className="button-group">                    
                    <button className="delete-btn" onClick={handleDelete} style={{ backgroundColor: "red", color: "white" }}><i className="fa fa-trash"></i></button>                
                    <button className="addsave-btn" onClick={handleSave}>업데이트</button>
                </div>
              
                

            </div>
        </div>
    );
};

export default GovernmentEditModal;
